import {Component, OnInit, input} from '@angular/core';
import {Observable} from 'rxjs';
import * as fromProfile from '../store/profile.reducers';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';

@Component({
    selector: 'app-audit-no-mention',
    templateUrl: './audit-no-mention.component.html',
    styleUrls: ['./audit-no-mention.component.scss'],
    standalone: false
})
export class AuditNoMentionComponent implements OnInit {

  readonly name = input<string>(undefined);
  readonly type = input<string>(undefined);
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
  }

}
